// @flow

export default (number: number, decimals: number = 1): string => {
  if (number % 1 === 0) {
    return number.toFixed(0);
  }

  return number.toFixed(decimals);
};
